/* Uses Sense's confirmed variant event. The native form remains the source of truth. */
if (!customElements.get('nightform-gallery')) {
  customElements.define('nightform-gallery', class extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.querySelector('[data-nf-main]');
      this.caption = this.querySelector('[data-nf-caption]');
      this.buttons = [...this.querySelectorAll('[data-nf-shot]')];
      try { this.variants = JSON.parse(this.querySelector('[data-nf-variants]').textContent); }
      catch (_) { this.variants = {}; }
      this.selectedId = this.querySelector('[data-nf-selected-id]')?.textContent.trim();
      this.onClick = (event) => {
        const button = event.target.closest('[data-nf-shot]');
        if (button && this.contains(button)) this.show(button.dataset.nfShot);
      };
      this.addEventListener('click', this.onClick);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId || !event.data.variant) return;
          this.selectedId = String(event.data.variant.id);
          const variant = this.variants[this.selectedId];
          if (variant?.image) this.querySelector('[data-nf-thumb]').src = variant.image;
          this.show('product');
        });
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.unsubscribe?.();
    }
    show(shot) {
      const button = this.buttons.find((item) => item.dataset.nfShot === shot);
      const variant = this.variants[this.selectedId];
      const image = shot === 'product' ? variant?.image : button?.dataset.image;
      if (!image) return;
      this.mainImage.src = image;
      this.mainImage.alt = shot === 'product'
        ? `Nightform sleep mask in ${variant.name}`
        : shot === 'detail' ? 'Interior contours of the mask, shown in Obsidian' : 'Nightform mask in use, shown in Obsidian';
      this.caption.textContent = shot === 'product' ? "A moment that's yours." : 'Shown in Obsidian';
      this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    }
  });
}
